module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "map"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("MAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "img-br"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "600",
      "src": "images/pgx.jpg",
      "width": "557"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "img-br"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "600",
      "src": "images/pgxi.jpg",
      "width": "560"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "img-br"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "600",
      "src": "images/pgxii.jpg",
      "width": "539"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "img-br"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "600",
      "src": "images/pgxiii.jpg",
      "width": "537"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Two dams that changed the Nile forever")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "600",
      "src": "images/pgxiv.jpg",
      "width": "541"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c16829","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/map.vue
// module id = 69
// module chunks = 0